import { render, staticRenderFns } from "./AdminCourse_chapters.vue?vue&type=template&id=e01d15c0&scoped=true&"
import script from "./AdminCourse_chapters.vue?vue&type=script&lang=js&"
export * from "./AdminCourse_chapters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01d15c0",
  null
  
)

export default component.exports